module.exports = __webpack_public_path__ + "img/copy_2_blue.fc6ffd49.svg";